module.exports = __webpack_public_path__ + "img/pointsIcon01.6f4b0b22.png";